function filterOutArchived(hit) {
  return !Boolean(hit.archivedAt)
}

export default function searchOnAlgolia({
  client,
  query,
  organization,
  snippetContentLength = 30,
}) {
  return new Promise((resolve, reject) => {
    client.search(
      [
        {
          indexName: 'notes',
          query,
          params: {
            analyticsTags: [`organization-${organization.id}`],
            restrictSearchableAttributes: ['title', 'content'],
            highlightPreTag: '<span class="font-weight-bold">',
            highlightPostTag: '</span>',
            attributesToSnippet: ['title', `content:${snippetContentLength}`],
            attributesToRetrieve: [
              'title',
              'channelId',
              'channelName',
              'fullPath',
              'objectID',
              'isArchived',
            ],
            snippetEllipsisText: '&hellip;',
            hitsPerPage: 50,
          },
        },
      ],
      (error, { results }) => {
        if (error) {
          return reject(error)
        }
        const [notesResults] = results
        const entries = notesResults.hits.filter(filterOutArchived)
        return resolve(entries)
      }
    )
  })
}
